module.exports = __webpack_public_path__ + "static/media/dummyEmail.a697e464.png";